/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '../../application';
import { LoggerModule } from '@vlinder-web/logger-module-react';
import { getAgent } from './agent';
import { ICreateOrderArgs } from './components';

const is = require('is_js');

const SERVICE_NAME = 'PurchasedCostumePageService';
const log: any = LoggerModule.getInstance();

export class PurchasedCostumePageService {
  private static instance: PurchasedCostumePageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): PurchasedCostumePageService {
    if (!PurchasedCostumePageService.instance) {
      PurchasedCostumePageService.instance = new PurchasedCostumePageService(props);
    }
    return PurchasedCostumePageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }


  public async getCities() {
    const agent = getAgent();
    let content: any = {};
    let compProps: any = null;
    compProps = await agent.getCities();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    compProps = await agent.getMyDiscounts();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async updateBox(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.updateBox(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getBoxes(year?: any, args?: any) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getBoxes(year, args);

    return content;
  }

  public async getBoxesYear() {
    let content: any = [];
    const agent = getAgent();

    content = await agent.getBoxesYear();
    return content;
  }

  public async createOrder(payload: ICreateOrderArgs) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.createOrder(payload);

    return content;
  }

  public async getInvoicePdf(payload: any) {
    let content: any = {};
    const agent = getAgent();

    content.invoiceLink = await agent.getInvoicePdf(payload);

    return content;
  }

  public async updateDelegateName(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.updateDelegateName(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
  public async validateDiscount(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.validateDiscount(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPastPurchaseOne(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getPastBoxesOne(arg);
    console.log(content);
    return content;
  }

  public async getPastPurchase(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getPastBoxes(arg);
    console.log(content, "qhd89");
    return content;
  }
  public async getBrandDetails() {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getBrandDetails();
    console.log(content, "qhd89");
    return content;
  }

  public async createPayFAC(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.createPayFAC({ ...arg });
    return content;
  }

}
